export default __webpack_public_path__ + "static/media/AKM_1.c03eed77.png";